module.exports = __webpack_public_path__ + "img/CellCycle-GBM_SPATA.0edfd304.png";